/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venue: NonNullable<unknown> }} Calendar_Venue_All_InInputs */

const cs_calendar_venue_all_in = /** @type {(inputs: Calendar_Venue_All_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Všichni v ${i?.venue}`)
};

const en_calendar_venue_all_in = /** @type {(inputs: Calendar_Venue_All_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Everyone in ${i?.venue}`)
};

/**
* | output |
* | --- |
* | "Everyone in {venue}" |
*
* @param {Calendar_Venue_All_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_venue_all_in = /** @type {((inputs: Calendar_Venue_All_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Venue_All_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_venue_all_in(inputs)
	return cs_calendar_venue_all_in(inputs)
});